import React from 'react';

export default function goLdMiniProgram({ content } = {}) {
  try {
    const isHy = content.indexOf('https://bk.jbzyun.com/sl/vuBUL') > -1;
    const userName = isHy
      ? 'gh_5e0a06ff7570' // 花园之吻 appid
      : 'gh_542025bff596'; // 乐道 appid
    const path = isHy ? `pages/index?isShare=1&id=5391830` : `pages/index?isShare=1&id=5394570`;
    return { userName, path };
  } catch (error) {
    console.log(error, 'err');
  }
}



// WEBPACK FOOTER //
// ./src/function/goThirdMiniProgram.js